/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import { defineMessages } from 'react-intl'

export const APPLICANT_ROLE = '0'
export const INTERPRETER_ROLE = '1'
export const PAYING_CUSTOMER_ROLE = '2'

export const APPLICANT_PRESTATION_USER_VIEW_TYPE = '0'
export const APPLICANT_PRESTATION_APPLICANT_VIEW_TYPE = '1'
export const APPLICANT_PRESTATION_ENTITY_VIEW_TYPE = '2'
export const APPLICANT_PRESTATION_IDENTITY_VIEW_TYPE = '3'

export const messages = defineMessages({
  TITLE: {
    id: 'login.TITLE',
    defaultMessage: 'TITLE'
  },
  USERNAME_LABEL: {
    id: 'login.USERNAME_LABEL',
    defaultMessage: 'USERNAME_LABEL'
  },
  PASSWORD_LABEL: {
    id: 'login.PASSWORD_LABEL',
    defaultMessage: 'PASSWORD_LABEL'
  },
  LOGIN_LABEL: {
    id: 'login.LOGIN_LABEL',
    defaultMessage: 'LOGIN_LABEL'
  },
  NO_LOGIN_LABEL: {
    id: 'login.NO_LOGIN_LABEL',
    defaultMessage: 'NO_LOGIN_LABEL'
  },
  CONTACT_TITLE_LABEL: {
    id: 'login.CONTACT_TITLE_LABEL',
    defaultMessage: 'CONTACT_TITLE_LABEL'
  },
  ENTITY_LABEL: {
    id: 'login.ENTITY_LABEL',
    defaultMessage: 'ENTITY_LABEL'
  },
  LAST_NAME_LABEL: {
    id: 'login.LAST_NAME_LABEL',
    defaultMessage: 'LAST_NAME_LABEL'
  },
  FIRST_NAME_LABEL: {
    id: 'login.FIRST_NAME_LABEL',
    defaultMessage: 'FIRST_NAME_LABEL'
  },
  FUNCTION_LABEL: {
    id: 'login.FUNCTION_LABEL',
    defaultMessage: 'FUNCTION_LABEL'
  },
  PHONE_LABEL: {
    id: 'login.PHONE_LABEL',
    defaultMessage: 'PHONE_LABEL'
  },
  EMAIL_LABEL: {
    id: 'login.EMAIL_LABEL',
    defaultMessage: 'EMAIL_LABEL'
  },
  RESPONSIBLE_LAST_NAME_LABEL: {
    id: 'login.RESPONSIBLE_LAST_NAME_LABEL',
    defaultMessage: 'RESPONSIBLE_LAST_NAME_LABEL'
  },
  RESPONSIBLE_FIRST_NAME_LABEL: {
    id: 'login.RESPONSIBLE_FIRST_NAME_LABEL',
    defaultMessage: 'RESPONSIBLE_FIRST_NAME_LABEL'
  },
  RESPONSIBLE_PHONE_LABEL: {
    id: 'login.RESPONSIBLE_PHONE_LABEL',
    defaultMessage: 'RESPONSIBLE_PHONE_LABEL'
  },
  RESPONSIBLE_EMAIL_LABEL: {
    id: 'login.RESPONSIBLE_EMAIL_LABEL',
    defaultMessage: 'RESPONSIBLE_EMAIL_LABEL'
  },
  RESPONSIBLE_FUNCTION_LABEL: {
    id: 'login.RESPONSIBLE_FUNCTION_LABEL',
    defaultMessage: 'RESPONSIBLE_FUNCTION_LABEL'
  },
  CONTACT_ACTION_CANCEL: {
    id: 'login.CONTACT_ACTION_CANCEL',
    defaultMessage: 'CONTACT_ACTION_CANCEL'
  },
  CONTACT_ACTION_SUBMIT: {
    id: 'login.CONTACT_ACTION_SUBMIT',
    defaultMessage: 'CONTACT_ACTION_SUBMIT'
  },
  ADDRESS_LABEL: {
    id: 'login.ADDRESS_LABEL',
    defaultMessage: 'ADDRESS_LABEL'
  },
  NP_LABEL: {
    id: 'login.NP_LABEL',
    defaultMessage: 'NP_LABEL'
  },
  LOCATION_LABEL: {
    id: 'login.LOCATION_LABEL',
    defaultMessage: 'LOCATION_LABEL'
  },
  REMARK_LABEL: {
    id: 'login.REMARK_LABEL',
    defaultMessage: 'REMARK_LABEL'
  },
  CONFIRMATION_CONTACT: {
    id: 'login.CONFIRMATION_CONTACT',
    defaultMessage: 'CONFIRMATION_CONTACT'
  },
  PRESTATION_URGENT_LABEL: {
    id: 'login.PRESTATION_URGENT_LABEL',
    defaultMessage: 'PRESTATION_URGENT_LABEL'
  },
  PHONE_NUMBER_LABEL: {
    id: 'login.PHONE_NUMBER_LABEL',
    defaultMessage: 'PHONE_NUMBER_LABEL' 
  },
  LANGUAGE_LABEL: {
    id: 'login.LANGUAGE_LABEL',
    defaultMessage: 'LANGUAGE_LABEL' 
  },
  CANCEL_LABEL: {
    id: 'login.CANCEL_LABEL',
    defaultMessage: 'CANCEL_LABEL'   
  },
  CREATE_LABEL: {
    id: 'login.CREATE_LABEL',
    defaultMessage: 'CREATE_LABEL'       
  },
  ONLY_APPLICANT: {
    id: 'login.ONLY_APPLICANT',
    defaultMessage: 'ONLY_APPLICANT'        
  },
  MANDATORY_LABEL: {
    id: 'login.MANDATORY_LABEL',
    defaultMessage: 'MANDATORY_LABEL' 
  },
  MANDATORY_MESSAGE: {
    id: 'login.MANDATORY_MESSAGE',
    defaultMessage: 'MANDATORY_MESSAGE' 
  },
  PRESTATION_URGENT_CONFIRMATION: {
    id: 'login.PRESTATION_URGENT_CONFIRMATION',
    defaultMessage: 'PRESTATION_URGENT_CONFIRMATION' 
  }
})



// WEBPACK FOOTER //
// ./src/constants/Login.js